import { CampaignErrorHandleField } from 'components/campaign/campaignCreation/CreateCampaignHandleError';
import { StampCampaignErrorHandleField } from 'components/stampCampaign/stampCampaignCreation/CreateStampCampaignHandleError';
import { CampaignType, EarningRuleRewardType, LanguageConfig, TARGET_CUSTOMER_TYPE } from 'config/CustomEnums';
import { ProcessEnvConfig } from 'config/ProcessEnvConfig';
import { validateRecurringPeriod } from 'containers/engagement/campaign/RecurringDateValidate'
import { recurringMessageValidate } from '../campaign/RecurringMessageValidate';

import { checkIsPositiveInteger } from 'utils';
import { TimeFormater, formatDate } from 'utils/TimeFormatUtil';
import { IMAGE_TYPES } from 'models/UploadFilesModel';
import { BannerErrorFields } from 'models/HomeBannersModel';
import { validateEarningPage } from '../earningRule/CreateEarningRuleValidate';
import { couponBaseInfoValidate, couponCodeValidate, couponTemplateAdditionalDataValidate } from '../coupon/CreateCouponValidate';
import { couponSetFieldPrefix, getCouponSetMedium } from './CreateCampaignCouponPageConfig';
import { getHideInFrontend } from 'models/CreateCampaignModel';
import { CouponErrorFields } from 'components/coupon/couponCreation/CouponHandleError';
import {
  CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY,
  CAMPAIGN_COUPON_PAGE_ANCHOR_KEY,
  CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY,
  COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY
} from 'config/PageAnchorConfig/CampaignAnchorConfig';

function recurringDateValidate({ getValues, errorList, hideInFrontend = false }) {
  const [
    isBirthdayRecurringCampaign,
    recurringDate,
  ] = getValues([
    'isBirthdayRecurringCampaign',
    'recurringDate',
  ]);
  if (!isBirthdayRecurringCampaign || !recurringDate) {
    return
  }
  validateRecurringPeriod({ isActive: true, isStart: true, recurringDate, errorList })
  validateRecurringPeriod({ isActive: true, isStart: false, recurringDate, errorList })
  if (!hideInFrontend) {
    validateRecurringPeriod({ isActive: false, isStart: true, recurringDate, errorList })
    validateRecurringPeriod({ isActive: false, isStart: false, recurringDate, errorList })
  }
};

export const validateContentPage = ({
  getValues,
  languages,
  hideInFrontend,
}) => {
  const errorList = [];

  languages.forEach((language) => {
    const genenralNameField = `translations.${language}.generalName`;
    const [generalName] = getValues([genenralNameField]);
    if (
      (language === LanguageConfig.english && !generalName) ||
      (!!generalName && generalName.length > 200)
    ) {
      errorList.push({
        sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.general.sectionKey,
        name: genenralNameField,
        message: CampaignErrorHandleField.generalName.message
      });
    }
  });

  const [
    campaignType,
    isExclusive,
    generalType,
    dynamicSegments,
    staticSegments,
    levels,
    excludeBlacklistSegment,
    blacklistSegments,
    coverPhoto,
    square,
    haveHomepageBanner,
    bannerVisiblePeriodFollowLinkedCampaign,
    bannerVisiblePeriodStartDate,
    bannerVisiblePeriodEndDate,
    bannerCoverPhoto,
    bannerOrder,
    malls,
    isAlwaysActivePeriod,
    activeStartDate,
    activeEndDate,
    isAlwaysVisiblePeriod,
    visibleStartDate,
    visibleEndDate,

  ] = getValues([
    "campaignType",
    "isExclusive",
    "generalType",
    "dynamicSegments",
    "staticSegments",
    "levels",
    "excludeBlacklistSegment",
    "blacklistSegments",
    "translations.en.coverPhoto",
    "translations.en.squareCoverPhoto",
    "haveHomepageBanner",
    "banner.visiblePeriodFollowLinkedCampaign",
    "banner.visiblePeriodStartDate",
    "banner.visiblePeriodEndDate",
    "banner.translations.en.coverPhotos.0",
    "banner.order",
    "malls",
    "isAlwaysActivePeriod",
    "activeStartDate",
    "activeEndDate",
    "isAlwaysVisiblePeriod",
    "visibleStartDate",
    "visibleEndDate",

  ]);

  if (isExclusive) {
    if (
      (generalType === TARGET_CUSTOMER_TYPE.DYNAMIC_SEGMENT && !dynamicSegments?.length)
      || (generalType === TARGET_CUSTOMER_TYPE.STATIC_SEGMENT && !staticSegments?.length)
    ) {
      errorList.push({
        sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionKey,
        name: CampaignErrorHandleField.segment.name,
        message: CampaignErrorHandleField.segment.message,
      });
    }
    else if (generalType === TARGET_CUSTOMER_TYPE.LEVEL && !levels?.length) {
      errorList.push({
        sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionKey,
        name: CampaignErrorHandleField.levels.name,
        message: CampaignErrorHandleField.levels.message,
      });
    }
  };

  if (excludeBlacklistSegment && !blacklistSegments?.length) {
    errorList.push({
      sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionKey,
      name: CampaignErrorHandleField.blacklistSegments.name,
      message: CampaignErrorHandleField.blacklistSegments.message,
    });
  };

  if (!hideInFrontend && (!coverPhoto || (coverPhoto?.type && coverPhoto.type !== IMAGE_TYPES.TYPE_URL))) {
    errorList.push({
      sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionKey,
      name: 'translations.en.coverPhoto',
      message: CampaignErrorHandleField.coverPhoto.message,
    });
  }
  if (!hideInFrontend && isExclusive && (!square || (square?.type && square.type !== IMAGE_TYPES.TYPE_URL))) {
    errorList.push({
      sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionKey,
      name: 'translations.en.squareCoverPhoto',
      message: CampaignErrorHandleField.squarePhoto.message,
    });
  }

  if (!hideInFrontend && haveHomepageBanner) {
    if (!bannerVisiblePeriodFollowLinkedCampaign && !isAlwaysVisiblePeriod) {
      if (
        visibleStartDate &&
        new Date(bannerVisiblePeriodStartDate) < new Date(visibleStartDate)
      ) {
        errorList.push({
          sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionKey,
          name: "banner.visiblePeriodFollowLinkedCampaign",
          message: "The selected period must be within the linked campaign's visible period, please try again.",
        });
        errorList.push({
          name: "banner.visiblePeriodStartDate",
          message: "The visible period must be equal or shorter than the linked banner's visible period, please try again.\n" +
            `The linked campaign start date: ${formatDate(
              visibleStartDate,
              TimeFormater.dayMonthYearWeekTimePeriod,
            )}`,
        });
        errorList.push({
          name: "homepageBannerVisiblePeriod",
          message: "error",
        });
        errorList.push({
          sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionKey,
          name: 'visibleStartDate',
          message:
            "The visible period must be equal or longer than the linked campaign's visible period, please try again.\n" +
            `The linked banner end date: ${formatDate(
              bannerVisiblePeriodStartDate,
              TimeFormater.dayMonthYearWeekTimePeriod,
            )}`,
        });
        errorList.push({
          name: "readableVisiblePeriod",
          message: "error",
        });
      }
      if (
        visibleEndDate &&
        new Date(bannerVisiblePeriodEndDate) > new Date(visibleEndDate)
      ) {
        errorList.push({
          sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionKey,
          name: "banner.visiblePeriodFollowLinkedCampaign",
          message: "The selected period must be within the linked campaign's visible period, please try again.",
        });
        errorList.push({
          name: "banner.visiblePeriodEndDate",
          message: "The visible period must be equal or shorter than the linked banner's visible period, please try again.\n" +
            `The linked campaign end date: ${formatDate(
              visibleEndDate,
              TimeFormater.dayMonthYearWeekTimePeriod,
            )}`,
        });
        errorList.push({
          name: "homepageBannerVisiblePeriod",
          message: "error",
        });
        errorList.push({
          sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionKey,
          name: 'visibleEndDate',
          message:
            "The visible period must be equal or longer than the linked campaign's visible period, please try again.\n" +
            `The linked banner end date: ${formatDate(
              bannerVisiblePeriodEndDate,
              TimeFormater.dayMonthYearWeekTimePeriod,
            )}`,
        });
        errorList.push({
          name: "readableVisiblePeriod",
          message: "error",
        });
      }
    }

    if (!bannerCoverPhoto || (bannerCoverPhoto?.type && bannerCoverPhoto?.type !== IMAGE_TYPES.TYPE_URL)) {
      errorList.push({
        sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionKey,
        name: 'banner.translations.en.coverPhotos',
        message: BannerErrorFields.bannerImage.message,
      });
    };
    if (!bannerOrder) {
      errorList.push({
        sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionKey,
        name: 'banner.order',
        message: BannerErrorFields.order.message,
      });
    }
  }

  if (ProcessEnvConfig.haveShopMall && !hideInFrontend && (!malls || malls?.length <= 0)) {
    errorList.push({
      sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionKey,
      name: 'malls',
      message: 'Please select a mall',
    });
  }

  if (!isAlwaysActivePeriod) {
    if (new Date(activeStartDate).getTime() >= new Date(activeEndDate).getTime()) {
      errorList.push({
        sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.activePeriod.sectionKey,
        name: 'activeEndDate',
        message: CampaignErrorHandleField.activeEndDate.message,
      });
      errorList.push({
        name: "readableActivePeriod",
        message: "error",
      });
    }
  }

  if (!hideInFrontend && !isAlwaysVisiblePeriod) {
    if (new Date(visibleStartDate).getTime() >= new Date(visibleEndDate).getTime()) {
      errorList.push({
        sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionKey,
        name: 'visibleEndDate',
        message: CampaignErrorHandleField.visibleEndDate.message,
      });
      errorList.push({
        name: "readableVisiblePeriod",
        message: "error",
      });
    }
  }

  recurringDateValidate({ getValues, errorList, hideInFrontend });
  recurringMessageValidate({ getValues, errorList });

  return errorList;
};

const validateCouponPage = ({ getValues }) => {
  const [
    stores,
  ] = getValues([
    `${couponSetFieldPrefix}selectedStores`,
  ]);
  const mediumType = getCouponSetMedium(stores)
  let errorList = [
    ...couponBaseInfoValidate({ getValues, prefix: couponSetFieldPrefix }),
    ...couponCodeValidate({ getValues, prefix: couponSetFieldPrefix, mediumType }),
    ...couponTemplateAdditionalDataValidate({ getValues, prefix: couponSetFieldPrefix }),
  ]
    if (
      (!stores || stores?.length <= 0)
    ) {
      errorList.push({
        sectionKey: CAMPAIGN_COUPON_PAGE_ANCHOR_KEY.applicableStores.sectionKey,
        name: `${couponSetFieldPrefix}selectedStores`,
        message: CouponErrorFields.applicationStore.message,
      });
    }

  return errorList
}

const validateCouponCampaignRulePage = ({ getValues }) => {
  const [
    campaignType,
    requiredPoints,
  ] = getValues([
    "campaignType",
    "requiredPoints",
  ]);
  let errorList = []

  if (campaignType === CampaignType.couponsCampaign) {
    const requiredPointsIsValid = checkIsPositiveInteger(requiredPoints);
    if (!requiredPointsIsValid) {
      errorList.push({
        sectionKey: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.requirementsSection.sectionKey,
        name: 'requiredPoints',
        message: CampaignErrorHandleField.requiredPoints.message,
      });
    }
  }
  return errorList
}

const validatePreviewPage = ({ getValues, checkCheckList }) => {
  const [
    campaignPk,
    campaignType,
    haveCreatedCoupon,
    checkList,
  ] = getValues([
    'pk',
    'campaignType',
    'haveCreatedCoupon',
    'checkList',
  ]);

  const haveCheckList = campaignType === CampaignType.couponsCampaign && (
    haveCreatedCoupon || !campaignPk
  );

  if (!haveCheckList || Object.keys(checkList || {}).length === 0 || !checkCheckList) {
    return [];
  }
  const errorList = [];
  (Object.entries(checkList) || []).forEach(([key, value]) => {
    if (!value) {
      errorList.push({
        sectionKey: CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.checklist,
        name: 'checkList',
        message: CampaignErrorHandleField.checkList.message,
      });
    }
  });
  return errorList;
}

export function validate({
  stepWithCoupon = false,
  dispatch,
  getValues,
  setError,
  clearErrors,
  checkCheckList = false,
  languages = [LanguageConfig.english],
}) {
  console.log('@@287 campaignValidate:', getValues());
  clearErrors();
  const campaignType = getValues('campaignType');

  let errorList = [];
  const errorSectionList = []
  const hideInFrontend = getHideInFrontend({ getValues });

  const contentPageError = validateContentPage({ getValues, languages, hideInFrontend });
  const previewPageError = validatePreviewPage({ getValues, checkCheckList });
  errorList = [
    ...contentPageError,
    ...previewPageError,
  ];
  if (campaignType === CampaignType.earningRulesCampaign) {
    const earningPageError = validateEarningPage({ getValues, prefix: "linkedEarningRules.", isCampaignStreamLine: true });
    errorList = [
      ...errorList,
      ...earningPageError,
    ];
  };
  if (campaignType === CampaignType.couponsCampaign) {
    const couponCampaignRuleError = validateCouponCampaignRulePage({ getValues });
    errorList = [
      ...errorList,
      ...couponCampaignRuleError,
    ];
  }
  if (stepWithCoupon) {
    const couponPageError = validateCouponPage({ getValues });
    errorList = [
      ...errorList,
      ...couponPageError,
    ];
  }
  errorList.forEach(item => {
    if (item.sectionKey) {
      errorSectionList.push(item.sectionKey);
    }
  })
  console.log("@@297", errorList, errorSectionList);

  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });

  dispatch({
    type: 'createCampaign/updateState',
    payload: {
      errorFields: errorList.map(item => item.name),
      errorSectionList,
    }
  })

  return !errorList.length;
};
